import { MsalProvider } from "@azure/msal-react";
import LoginPage from "./pages/loginPage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/dashboard.jsx";
import { useDispatch, useSelector } from "react-redux";
import Layout from "./layout";
import UrlScrapper from "./pages/UrlScrapper.jsx";
import FileUploader from "./pages/FIleUploader/index.jsx";
import FileDetailsPage from "./pages/FIleUploader/fileDetailsPage.jsx";
import ActivationEmailSender from "./pages/ActivationEmailSender/index.jsx";
import TaskRestarter from "./pages/TaskRestarter/index.jsx";
import ActivationEmailSenderPaid from "./pages/ActivationEmailSenderPaid/index.jsx";
import AddCompany from "./pages/AddCompany/index.jsx";
import FileUpload_2 from "./pages/FileUpload_2.jsx";
import DashboardTiles from "./pages/DashboardTiles/index.jsx";
import Subscriptions from "./pages/Subscriptions/index.jsx";
import { login, logout } from "./store/slice/authSlice.js";
import Layouts from "./pages/Layouts/index.jsx";
import useAxiosInstance from "./hooks/useAxios.jsx";
import React, { useEffect, useState } from "react";
import FileDetailsPage_v1 from "./pages/FIleUploader/fileDetailesPageV1.jsx";
import CompanyRequests from "./pages/CompanyRequests/index.jsx";
import CompanyMigrations from "./pages/CompanyMigrations/index.jsx";
import GenerateActivationLink from "./pages/ActivationLink/index.jsx";
import ActivationEmailBulkSupport from "./pages/ActivationEmailBulkSupport/index.jsx";
import FileUploads from "./pages/FileUploads/index.jsx";
import AllOrganisation from "./pages/Organisations/allOrganisation.jsx";
import {
  setOrganisation,
  setAccountType,
  setAllComponentsIds,
  setAllReportCategory,
  setAllDocTemplate,
  setAllOrgProfileTypes,
  setAllOrganizations,
  setAllViews,
  setAllReportTypes,
} from "./store/slice/GlobalAuth.js";
import AddOrganisation from "./pages/Organisations/addOrganisation.jsx";
import EditOrganisation from "./pages/Organisations/editOrganisation.jsx";
import AllUsers from "./pages/Users/allUsers.jsx";
import EditUsers from "./pages/Users/editUsers.jsx";
import NewsletterConfiguration from "./pages/newsletter-config/index.jsx";
import ReportPage from "./pages/ReportPage/index.jsx";
import AllConfigs from "./pages/newsletter-config/allConfigs.jsx";
import ReportMigration from "./pages/ReportMigration/reportMigration.jsx";
import ChatMigration from "./pages/ChatMigration/chatMigration.jsx";
import ChatEditor from "./pages/ChatEditor/chatEditor.jsx";
import SubscriptionPageV2 from "./pages/SubscriptionPageV2/index.jsx";
import EmailSender from "./pages/EmailSender/index.jsx";
import DalleImgGen from "./pages/DalleImgGen/index.jsx";
import Playground from "./pages/Playground/index.jsx";
import AllPosts from "./pages/DeveloperPosts/AllPosts.jsx";
import AddPosts from "./pages/DeveloperPosts/addPosts.jsx";
import EditPosts from "./pages/DeveloperPosts/editPosts.jsx";
import NewsletterReviver from "./pages/NewsletterReviver/index.jsx";
import CosmosResults from "./pages/Cosmos/index.jsx";
import MarketMapSearch from "./pages/MarketMapPage/index.jsx";
import AllNotification from "./pages/Notification/allNotification.jsx";
import AddNotification from "./pages/Notification/addNotification.jsx";
import EditNotification from "./pages/Notification/editNotification.jsx";
import SeeAllNewsletterAccess from "./pages/NewsletterAccess/SeeAllAccess.jsx";
import NewsletterAccessDetailPage from "./pages/NewsletterAccess/TypePage.jsx";
import BlukAddOrEditNewsletterAccess from "./pages/NewsletterAccess/BlukAddOrRemove.jsx";
import PreferencesDetailedView from "./pages/UserPreferences/PreferencesDetailedView.jsx";
import Scheduler from "./pages/Scheduler/scheduler.jsx";
import AllScheduler from "./pages/Scheduler/AllScheduler.jsx";
import EditScheduler from "./pages/Scheduler/editScheduler.jsx";
import CBEnrichment from "./pages/CBEnrichment/index.jsx";
import ReportCopy from "./pages/ReportCopy/index.jsx";
import QnAData from "./pages/QnAData/index.jsx";
import PendingRequests from "./pages/PendingRequests/index.jsx";
import AllReportTypes from "./pages/AllReportTypes/AllReportTypes.jsx";
import EditReportType from "./pages/AllReportTypes/EditReportType.jsx";
import BulkViewOrgProducts from "./pages/SubscriptionV3/index.jsx";
import EditBulkOrgSubscription from "./pages/SubscriptionV3/EditOrg.jsx";
import { FaSpinner } from "react-icons/fa";
import Breakpoints from "./pages/Breakpoints/index.jsx";
import CompanyNews from "./pages/CompanyNews/CompanyNews.jsx";
import AddEditCompanyNews from "./pages/CompanyNews/AddCompanyNews.jsx";
import NewsletterConfigFromExcel from "./pages/NewsletterConfigFromExcel/NewsletterConfigFromExcel.jsx";
import NewsletterStart from "./pages/NewsletterStart/NewsletterStart.jsx";
import NewsletterMigration from "./pages/NewsletterMigration/NewsletterMigration.jsx";
import ObservabilityMetrics from "./pages/Observablity/ObservablityMetics.jsx";
import ObservabilityLogs from "./pages/Observablity/ObservablityLogs.jsx";
import AddProductVideo from "./pages/ProductVideos/AddProductVideo.jsx";
import EditProductVideo from "./pages/ProductVideos/EditProductVideo.jsx";
import AllProductVideo from "./pages/ProductVideos/AllProductVideo.jsx";
import ReportPause from "./pages/ReportPause/ReportPause.jsx";
import ReportTracebility from "./pages/ReportTracebility/ReportTracebility.jsx";
import EnglishTranslator from "./pages/EnglishTranslator/EnglishTranslator.jsx";
import DBMigration from "./pages/DbMigration/DbMigration.jsx";
import ReportCopyOrg from "./pages/ReportCopyOrg/ReportCopyOrg.jsx";
import UserPreferencesBulkEdit from "./pages/UserPreferences/UserPreferencesBulkEdit.jsx";
import GeneralScrapperPdf from "./pages/GeneralScrapperPdf/GeneralScrapperPdf.jsx";
import EditFunction from "./pages/AtlasSearch/EditFunction.jsx";
import AtlasSearch from "./pages/AtlasSearch/AtlasSearch.jsx";
import AddAffinity from "./pages/Affinity/addAffinity.jsx";
import EditAffinity from "./pages/Affinity/editAffinity.jsx";
import AllAffinity from "./pages/Affinity/allAffinity.jsx";
import PlaygroundV2 from "./pages/PlaygroundV2/PlaygroundV2.jsx";
import ImageGen from "./pages/ImageGen/ImageGen.jsx";
import PPTQuery from "./pages/PPTQuery/index.jsx";
import ReportTypePreview from "./pages/ReportTypePreview/ReportTypePreview.tsx";
import EditPPTDeck from "./pages/EditPPTDeck/index.jsx";
import ManagePPTTemplates from "./pages/ManagePPTTemplates/index.jsx";
import CustomAgentsPage from "./pages/CustomAgents/index.jsx";
import OrgAgentsPage from "./pages/CustomAgents/OrgAgents.jsx";
import MetricQueryExplorer from "./pages/MetricQueryExplorer/index.jsx";
import CreditManagement from "./pages/CreditManagement/index.jsx";
import CreditHistory from "./pages/CreditHistory/CreditHistory.jsx";
import MiniMaxQuota from "./pages/MiniMaxQuota/index.jsx";
import AddAktaTool from "./pages/AddAktaTool/index.jsx";
import AddEnterpriseWokeloTool from "./pages/AddEnterpriseWokeloTool/index.jsx";
import ArticleGroups from "./pages/ArticleGroups/index.jsx";
import SectionWiseCreditDistribution from "./pages/SectionWiseCreditDistribution/index.jsx";
import APIUsage from "./pages/APIUsage/index.jsx";
import NewsletterEditor from "./pages/NewsletterEditor/index.jsx";

export const listOfSubscription = ["Pro", "Beta", "default", "Hidden", "Lock"];

function App({ instance }) {
  const axios = useAxiosInstance();
  const authData = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const localStorageData = JSON.parse(
    localStorage.getItem("wokelo-sandbox-auth-token"),
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorageData !== null) {
      dispatch(login(localStorageData));
    } else {
      dispatch(logout());
    }
  }, [localStorageData]);

  React.useEffect(() => {
    axios
      .get(`accounts/organisations/`)
      .then((res) => {
        dispatch(setOrganisation(res.data.organisations));
      })
      .catch((err) => {
        console.log("Error detected so logging out");
      });
  }, []);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get(`assets/get_base_sandbox_settings/`)
      .then((res) => {
        setLoading(false);
        dispatch(setAccountType(res.data.all_account_types));
        dispatch(setAllComponentsIds(res.data.all_components_ids));
        dispatch(setAllReportCategory(res.data.all_report_category));
        dispatch(setAllDocTemplate(res.data.all_doc_template));
        dispatch(setAllOrgProfileTypes(res.data.all_org_profile_types));
        dispatch(setAllOrganizations(res.data.all_organizations));
        dispatch(setAllViews(res.data.all_views));
        dispatch(setAllReportTypes(res.data.all_report_types));
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error detected so logging out");
      });
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[100vh] w-full">
        <div>
          <p className="text-sm font-semibold">Wokelo Sandbox</p>
          <div className="flex justify-center mt-3 animate-spin">
            <FaSpinner />
          </div>
        </div>
      </div>
    );
  }
  return (
    <MsalProvider instance={instance}>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Routes>
          <Route
            path="/"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <Dashboard />
                </Layout>
              )
            }
          />
          <Route
            path="/companyRequests"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <CompanyRequests />
                </Layout>
              )
            }
          />
          <Route
            path="/companyMigrations"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <CompanyMigrations />
                </Layout>
              )
            }
          />
          <Route
            path="/generateActivationLink"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <GenerateActivationLink />
                </Layout>
              )
            }
          />
          <Route
            path="/urlScrapper"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <UrlScrapper />
                </Layout>
              )
            }
          />
          <Route
            path="/subscriptions"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <Subscriptions />
                </Layout>
              )
            }
          />
          <Route
            path="/AllUsers"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllUsers />
                </Layout>
              )
            }
          />
          <Route
            path="/EditUsers"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditUsers />
                </Layout>
              )
            }
          />
          <Route
            path="/AllOrganisation"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllOrganisation />
                </Layout>
              )
            }
          />
          <Route
            path="/addOrganisation"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddOrganisation />
                </Layout>
              )
            }
          />
          <Route
            path="/editOrganisation"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditOrganisation />
                </Layout>
              )
            }
          />
          <Route
            path="/layouts"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <Layouts />
                </Layout>
              )
            }
          />
          <Route
            path="/fileUploader"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <FileUploader />
                </Layout>
              )
            }
          />
          <Route
            path="/FileUploads"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <FileUploads />
                </Layout>
              )
            }
          />
          <Route
            path="/dashboardTiles"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <DashboardTiles />
                </Layout>
              )
            }
          />
          <Route
            path="/V2fileUploader"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <FileUpload_2 />
                </Layout>
              )
            }
          />
          <Route
            path="/ActivationEmailTrial"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ActivationEmailSender />
                </Layout>
              )
            }
          />
          <Route
            path="/ActivationEmailPaid"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ActivationEmailSenderPaid />
                </Layout>
              )
            }
          />
          <Route
            path="/taskRestarter"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <TaskRestarter />
                </Layout>
              )
            }
          />
          <Route
            path="/addCompany"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddCompany />
                </Layout>
              )
            }
          />
          <Route
            path="/fileUploader/:id"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <FileDetailsPage />
                </Layout>
              )
            }
          />
          <Route
            path="/fileUploader-V1/:id"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <FileDetailsPage_v1 />
                </Layout>
              )
            }
          />
          <Route
            path="/ActivationEmailBulkAddition"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ActivationEmailBulkSupport />
                </Layout>
              )
            }
          />
          <Route
            path={`/bulkEditPreferences`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <UserPreferencesBulkEdit />
                </Layout>
              )
            }
          />
          <Route
            path="/newsletter-config"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <NewsletterConfiguration />
                </Layout>
              )
            }
          />

          <Route
            path="/all-configs"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllConfigs />
                </Layout>
              )
            }
          />

          <Route
            path="/report-migrations"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ReportMigration />
                </Layout>
              )
            }
          />

          <Route
            path="/chat-migrations"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ChatMigration />
                </Layout>
              )
            }
          />

          <Route
            path="/chat-editor"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ChatEditor />
                </Layout>
              )
            }
          />

          <Route
            path="/report-page-firmographics"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ReportPage />
                </Layout>
              )
            }
          />
          <Route
            path="/report-pause"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ReportPause />
                </Layout>
              )
            }
          />

          <Route
            path="/subscriptions-v2"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllOrganisation />
                </Layout>
              )
            }
          />
          <Route
            path="/subscriptions-v2/edit-product/:id"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <SubscriptionPageV2 />
                </Layout>
              )
            }
          />

          <Route
            path="/email-sender"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EmailSender />
                </Layout>
              )
            }
          />
          <Route
            path="/section-wise-credit-distribution"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <SectionWiseCreditDistribution />
                </Layout>
              )
            }
          />
          <Route
            path="/NewsletterEditor"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <NewsletterEditor />
                </Layout>
              )
            }
          />
          {/* NewsletterEditor */}
          <Route
            path="/dalle-img-gen"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <DalleImgGen />
                </Layout>
              )
            }
          />
          <Route
            path="/playground"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <Playground />
                </Layout>
              )
            }
          />
          <Route
            path="/playground_v2"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <PlaygroundV2 />
                </Layout>
              )
            }
          />
          <Route
            path="/ppt_query"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <PPTQuery />
                </Layout>
              )
            }
          />
          <Route
            path="/allposts"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllPosts />
                </Layout>
              )
            }
          />
          <Route
            path="/addpost"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddPosts />
                </Layout>
              )
            }
          />
          <Route
            path="/editpost/:id"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditPosts />
                </Layout>
              )
            }
          />
          <Route
            path="/NewsletterReviver"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <NewsletterReviver />
                </Layout>
              )
            }
          />
          <Route
            path="/CosmosResults"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <CosmosResults />
                </Layout>
              )
            }
          />
          <Route
            path="/report-tracebility"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ReportTracebility />
                </Layout>
              )
            }
          />
          <Route
            path="/market-map-search"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <MarketMapSearch />
                </Layout>
              )
            }
          />

          <Route
            path="/allNotification"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllNotification />
                </Layout>
              )
            }
          />
          <Route
            path="/addNotification"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddNotification />
                </Layout>
              )
            }
          />
          <Route
            path="/EditNotification"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditNotification />
                </Layout>
              )
            }
          />
          <Route
            path="/addProductVideo"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddProductVideo />
                </Layout>
              )
            }
          />
          <Route
            path="/editProductVideo"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditProductVideo />
                </Layout>
              )
            }
          />
          <Route
            path="/allProductVideo"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllProductVideo />
                </Layout>
              )
            }
          />

          <Route
            path="/mass_view_all_newsletters"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <SeeAllNewsletterAccess />
                </Layout>
              )
            }
          />

          <Route
            path="/newsletter-migration"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <NewsletterMigration />
                </Layout>
              )
            }
          />
          <Route
            path="/newsletterTypeAccessDetailPage"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <NewsletterAccessDetailPage />
                </Layout>
              )
            }
          />
          <Route
            path="/bulkChangesNewsletterAccess"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <BlukAddOrEditNewsletterAccess />
                </Layout>
              )
            }
          />
          <Route
            path="/preferencesDetailedView"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <PreferencesDetailedView />
                </Layout>
              )
            }
          />
          <Route
            path={`/allpreferences`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllUsers />
                </Layout>
              )
            }
          />
          <Route
            path={`/scheduler`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <Scheduler />
                </Layout>
              )
            }
          />
          <Route
            path={`/scheduler/edit/:id`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditScheduler />
                </Layout>
              )
            }
          />
          <Route
            path={`/scheduler/all`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllScheduler />
                </Layout>
              )
            }
          />
          <Route
            path={`/cb-enrichment/`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <CBEnrichment />
                </Layout>
              )
            }
          />
          <Route
            path={`/bulk-report-copy`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ReportCopy />
                </Layout>
              )
            }
          />
          <Route
            path={`/bulk-org-report-copy`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ReportCopyOrg />
                </Layout>
              )
            }
          />
          <Route
            path={`/qna-data`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <QnAData />
                </Layout>
              )
            }
          />
          <Route
            path={`/pending-requests`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <PendingRequests />
                </Layout>
              )
            }
          />
          <Route
            path={`/all-report-types`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllReportTypes />
                </Layout>
              )
            }
          />
          <Route
            path={`/report-preview`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ReportTypePreview />
                </Layout>
              )
            }
          />
          <Route
            path={`/edit-report-type/:id`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditReportType />
                </Layout>
              )
            }
          />

          <Route
            path={`/bulk-view-org-products`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <BulkViewOrgProducts />
                </Layout>
              )
            }
          />

          <Route
            path={`/bulk-view-org-products/details/`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditBulkOrgSubscription />
                </Layout>
              )
            }
          />

          <Route
            path={`/breakpoints`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <Breakpoints />
                </Layout>
              )
            }
          />

          <Route
            path={`/company-news/all`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <CompanyNews />
                </Layout>
              )
            }
          />
          <Route
            path={`/company-news/add`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddEditCompanyNews />
                </Layout>
              )
            }
          />
          <Route
            path={`/company-news/edit/`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddEditCompanyNews />
                </Layout>
              )
            }
          />
          <Route
            path={`/newsletter-config-from-excel`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <NewsletterConfigFromExcel />
                </Layout>
              )
            }
          />
          <Route
            path={`/newsletter-start`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <NewsletterStart />
                </Layout>
              )
            }
          />
          <Route
            path={`/observability-Metrics`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ObservabilityMetrics />
                </Layout>
              )
            }
          />
          <Route
            path={`/observability-logs`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ObservabilityLogs />
                </Layout>
              )
            }
          />
          <Route
            path="/report-traceability"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ReportTracebility />
                </Layout>
              )
            }
          />
          <Route
            path="/english-translator"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EnglishTranslator />
                </Layout>
              )
            }
          />
          <Route
            path={`/db-migration`}
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <DBMigration />
                </Layout>
              )
            }
          />
          <Route
            path="/general-scraper-pdf"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <GeneralScrapperPdf />
                </Layout>
              )
            }
          />
          <Route
            path="/atlassearch"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AtlasSearch />
                </Layout>
              )
            }
          />
          <Route
            path="/atlassearch/edit"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditFunction />
                </Layout>
              )
            }
          />
          <Route
            path="/add-affinity"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddAffinity />
                </Layout>
              )
            }
          />
          <Route
            path="/edit-affinity/:id"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditAffinity />
                </Layout>
              )
            }
          />
          <Route
            path="/all-affinity"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AllAffinity />
                </Layout>
              )
            }
          />
          <Route
            path="/image-gen"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ImageGen />
                </Layout>
              )
            }
          />
          <Route
            path="/manage-ppt-templates"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ManagePPTTemplates />
                </Layout>
              )
            }
          />
          <Route
            path="/edit-ppt-deck"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <EditPPTDeck />
                </Layout>
              )
            }
          />
          <Route
            path="/custom-agents"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <CustomAgentsPage />
                </Layout>
              )
            }
          />
          <Route
            path="/custom-agents/:orgId"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <OrgAgentsPage />
                </Layout>
              )
            }
          />
          <Route
            path="/metric-query-explorer"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <MetricQueryExplorer />
                </Layout>
              )
            }
          />
          <Route
            path="/credit-management"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <CreditManagement />
                </Layout>
              )
            }
          />
          <Route
            path="/credit-history"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <CreditHistory />
                </Layout>
              )
            }
          />
          <Route
            path="/minimax-quota"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <MiniMaxQuota />
                </Layout>
              )
            }
          />
          <Route
            path="/api-usage"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <APIUsage />
                </Layout>
              )
            }
          />
          <Route
            path="/add-akta-tool"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddAktaTool />
                </Layout>
              )
            }
          />
          <Route
            path="/add-akta-tool/:toolName"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddAktaTool />
                </Layout>
              )
            }
          />
          <Route
            path="/add-enterprise-tool"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddEnterpriseWokeloTool />
                </Layout>
              )
            }
          />
          <Route
            path="/add-enterprise-tool/:toolName"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <AddEnterpriseWokeloTool />
                </Layout>
              )
            }
          />
          <Route
            path="/article-groups"
            element={
              authData.username === "" ? (
                <LoginPage />
              ) : (
                <Layout>
                  <ArticleGroups />
                </Layout>
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </MsalProvider>
  );
}

export default App;
